import { useEffect, useState } from "react";

import CategorySlider from "../category-slider";
import BookCard from "../book-card";

function FeaturedSection({ categories, initailBooks }) {
  const [bestBooks, setBestBooks] = useState(initailBooks); //List of the best selling books.
  const [query, setQuery] = useState("");

  useEffect(() => {
    async function getSelectedCatBooks(cat) {
      try {
        const res = await fetch(
          `https://api.nytimes.com/svc/books/v3/lists/current/${cat}.json?api-key=GaESzDWgFVIjf5U4lLsTKDpm4N6uOI2m`
        );
        const data = await res.json();
        const results = data?.results || [];

        const featuredBooks = results?.books.slice(0, 6);

        setBestBooks(featuredBooks);
      } catch (error) {
        console.error("Error fetching active list books:", error);
      }
    }

    if (query?.trim()) {
      getSelectedCatBooks(query);
    } else {
      setBestBooks(initailBooks);
    }
  }, [query, initailBooks]);

  const handleCategoryClick = (e) => {
    if (e.target.classList.contains("active")) {
      const ele = e.target.getAttribute("data-id");
      setQuery(ele);
    } else {
      setQuery("");
    }
  };

  return (
    <section id="recent-book-list">
      <div className="container book-list">
        <div className="section-heading">
          <h2>Best Seller of this week</h2>
        </div>
        <CategorySlider
          list={categories}
          click={handleCategoryClick}
        ></CategorySlider>
        <div className="book-cards">
          {bestBooks.map((item) => (
            <BookCard
              key={
                item.primary_isbn13 ? item.primary_isbn13 : item.primary_isbn10
              }
              isbn={
                item.primary_isbn13 ? item.primary_isbn13 : item.primary_isbn10
              }
              img={item.book_image}
              author={item.author}
              title={item.title}
              des={item.description}
              buyUrl={item.amazon_product_url}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturedSection;
